module.exports = __webpack_public_path__ + "img/Ifeza.2de415e4.jpg";